import React from 'react';
import { useSelector } from 'react-redux';
import { selectNodeById } from 'store/graph/selectors';
import './person-card.css';

const PersonCard = ({ personId }) => {
  const person = useSelector(selectNodeById(personId));

  if (!person) {
    return <div className="person-card">Loading...</div>;
  }

  const personData = person.data || person;
  const displayName =
    personData?.name ||
    personData?.displayValue ||
    personData?.value ||
    person?.value ||
    'Unknown';
  
  const avatarUrl = personData?.imgSrc || personData?.blobUrl || person?.blobUrl;
  
  const getInitials = (name) => {
    return name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase();
  };
  
  const initials = getInitials(displayName);

  return (
    <div className="person-card">
      {avatarUrl ? (
        <img src={avatarUrl} alt={displayName} className="avatar" />
      ) : (
        <div className="avatar-placeholder" aria-hidden="true">
          {initials || '?'}
        </div>
      )}
      <div className="person-info">
        <span className="person-name">{displayName}</span>
        {personData?.nodeScore && (
          <span className="person-score">{personData.nodeScore}</span>
        )}
      </div>
    </div>
  );
};

export default PersonCard;
